import React, { Component, createRef } from 'react'; //different
import {
    BrowserRouter,
    Routes,
    Route
} from "react-router-dom";
import './App.css';
import Footer from './footer';
import jwt_decode from "jwt-decode";
import Swal from 'sweetalert2'
import instance from "./axios-instance";
import { NumericFormat } from 'react-number-format';
import Systems from "./SystemFunction";
import Casino from "./casino";
import Slot from "./slot";
import Fishing from "./fising";
import Sport from "./sport";
import TextSlider from "./textslide";
import Afficiate from "./affiliate";
import Signin from "./signin";
import Register from "./register";
import Loss from "./loss";
import Promotion from "./promotionx";
// import { isMobile } from 'react-device-detect';
import Profile from "./profile";
import Statement from "./statement";
import Banner from "./banner";
import MoblieMenu from "./mobilemenu";
import Mainindex from "./mainindex";
import Lowmenu from "./lowmenu";
import Popup from "./popup";
import EventPage from "./eventpage";
import Instructions from "./instructions";
import FaqPage from "./faqpage";
import PromotionsPage from "./promotionspage";
import ComparePage from "./comparepage";
// import Lotto from "./lotto";
import Listgameall from "./linklistall";
// import GameHit from "./gamehit";
import moment from 'moment';
import md5 from 'md5';
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { LoopTwoTone } from '@mui/icons-material';
import { ToastContainer, toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import NProgress from "nprogress";
import axios from 'axios';
var settings = {
    dots: false, // ซ่อนจุดนำทาง
    infinite: true, // วนลูป slides
    slidesToShow: 7, // แสดง 7 slide ในหน้าจอใหญ่ (ตรงกับ reference)
    slidesToScroll: 1, // เลื่อนทีละ 1 slide
    autoplay: true, // autoplay
    speed: 2000, // ความเร็วในการเลื่อน (ms)
    autoplaySpeed: 3000, // ช่วงเวลาระหว่าง autoplay
    cssEase: "linear", // ความเรียบเนียนของ transition
    centerMode: false, // ปิด center mode (reference ไม่ใช้ -> รูปไม่ลอยกลางช่อง)
    arrows: false, // ซ่อนปุ่มลูกศร (reference ไม่มี)
    responsive: [
        {
            breakpoint: 1024, // เมื่อหน้าจอเล็กกว่า 1024px
            settings: {
                slidesToShow: 5, // แสดง 5 slide
            },
        },
        {
            breakpoint: 760, // เมื่อหน้าจอเล็กกว่า 760px
            settings: {
                slidesToShow: 3, // แสดง 3 slide
            },
        },
    ],
};

const settingsx = {
    dots: true, // แสดงจุดบอกสถานะของสไลด์
    infinite: true, // สไลด์วนลูป
    speed: 500, // ความเร็วในการเลื่อนสไลด์ (ms)
    slidesToShow: 1, // จำนวนสไลด์ที่แสดง
    slidesToScroll: 1, // จำนวนสไลด์ที่เลื่อนต่อครั้ง
    autoplay: true, // เลื่อนอัตโนมัติ
    autoplaySpeed: 3000, // เวลาในแต่ละสไลด์ (ms)
    arrows: true // แสดงปุ่มเลื่อนซ้าย-ขวา
};

let isMobile = false;
if (window.innerWidth <= 760) isMobile = true;
class Main extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isOpen: false, // สถานะเปิด/ปิด Sidebar
            tabselect: 0,
            webname: "",
            logoimg: "",
            logoSrc: window.localStorage.getItem('siteLogo') || "",   // โลโก้ที่โชว์จริง (เริ่มจาก cache)
            linelink: "",
            webnamex: "",
            describemain: "",
            System: "",
            activeCategory: 'hot',
        }

    }

    toggleSidebar = () => {
        console.log("toggleSidebar")
        this.setState((prevState) => ({
            isOpen: !prevState.isOpen, // สลับสถานะเปิด/ปิด
        }));
    };
    checkurl = async (e, url) => {
        NProgress.start();
        const pathname = url.split("/")
        //  console.log(210, url.split("/"));
        if (pathname.length > 1) {
            if (!this.state.loginstate && pathname[1] == "listgameall") {
                this.setState({
                    tabselect: 23,
                });
                return;
            }
            else {
                window.history.pushState(null, null, url);
                this.setState({
                    modalx: false,
                    modal: false,
                });
                if (pathname[1] == "") {
                    console.log(250, pathname[1]);
                    this.setState({
                        tabselect: 0,
                    });
                }
                else if (pathname[1] == "casino") {
                    this.setState({ tabselect: 0, activeCategory: 'casino' });
                }
                else if (pathname[1] == "gamehit") {
                    this.setState({ tabselect: 0, activeCategory: 'hot' });
                }
                else if (pathname[1] == "fishing") {
                    this.setState({ tabselect: 0, activeCategory: 'fishing' });
                }
                else if (pathname[1] == "slot") {
                    this.setState({ tabselect: 0, activeCategory: 'slot' });
                }
                else if (pathname[1] == "sport") {
                    this.setState({ tabselect: 0, activeCategory: 'sport' });
                }
                else if (pathname[1] == "loss") {
                    this.setState({
                        tabselect: 25,
                    });
                }

                else if (pathname[1] === "sportblog") {
                    this.setState({
                        tabselect: 20,
                    });
                } else if (pathname[1] === "casinoblog") {
                    this.setState({
                        tabselect: 21,
                    });
                } else if (pathname[1] === "slotblog") {
                    this.setState({
                        tabselect: 22,
                    });
                } else if (pathname[1] === "sportbet") {
                    this.setState({
                        tabselect: 23,
                    });
                } else if (pathname[1] === "bacaratbet") {
                    this.setState({
                        tabselect: 24,
                    });
                } else if (pathname[1] === "lottoonline") {
                    this.setState({
                        tabselect: 25,
                    });
                } else if (pathname[1] === "promotionblog") {
                    this.setState({
                        tabselect: 26,
                    });
                } else if (pathname[1] === "blog") {
                    this.setState({
                        tabselect: 27,
                    });
                }

                else if (pathname[1] == "event") {
                    this.setState({ tabselect: 16 });
                }
                else if (pathname[1] == "promotion") {
                    this.setState({ tabselect: 7 });
                }
                else if (pathname[1] == "compare") {
                    this.setState({ tabselect: 30 });
                }
                else if (pathname[1] == "instructions") {
                    this.setState({ tabselect: 28 });
                }
                else if (pathname[1] == "faq") {
                    this.setState({ tabselect: 29 });
                }
                else if (pathname[1] == "lotto") {
                    this.setState({
                        tabselect: 17,
                    });
                }
                else if (pathname[1] == "withdraw") {
                    if (this.state.loginstate) {
                        this.setState({
                            tabselect: 2,
                        });
                    }
                    else {
                        this.setState({
                            tabselect: 0,
                        });
                    }
                }
                else if (pathname[1] == "deposit") {
                    this.setState({
                        tabselect: 1,
                        tabselectdeposit: 1,
                    });
                }
                else if (pathname[1] == "statement") {
                    this.setState({
                        tabselect: 3,
                    });
                }
                else if (pathname[1] == "profile") {
                    this.setState({
                        tabselect: 8,
                    });
                }
                else if (pathname[1] == "register") {
                    this.setState({
                        tabselect: 22,
                    });
                }
                else if (pathname[1] == "signin") {
                    this.setState({
                        tabselect: 23,
                    });
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/overview") {
                    this.setState({
                        tabselect: 4,
                        refer: 1
                    });
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/member") {
                    this.setState({
                        tabselect: 4,
                        refer: 2
                    });
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/income-summary") {
                    this.setState({
                        tabselect: 4,
                        refer: 3
                    });
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/share-network") {
                    this.setState({
                        tabselect: 4,
                        refer: 4
                    });
                }
                else if (pathname[1] == "rebate") {
                    this.setState({
                        tabselect: 5,
                    });
                }
                else if (pathname[1] == "promotion") {
                    this.setState({
                        tabselect: 7,
                    });
                }
                else if (pathname[1] == "listgameall") {
                    let check = await this.getgame(pathname[2], pathname[3], true);
                    console.log(614, check)
                    if (check) {
                        this.setState({
                            tabselect: 15,
                        });
                    }
                }
            }
        }
        else {
            this.setState({
                tabselect: 0,
            });
        }
        NProgress.done();
    }

    getCache = (key, ttl) => {
        const cachedDataStr = localStorage.getItem(key);
        console.log("Raw cached data:", cachedDataStr);

        const cachedData = cachedDataStr ? JSON.parse(cachedDataStr) : null;
        if (cachedData) {
            console.log("Cache timestamp:", cachedData.expiry);
            console.log("Current time:", Date.now());
            console.log("TTL:", ttl);

            if (Date.now() < cachedData.expiry) {
                console.log("Using valid cached data:", cachedData.value);
                return cachedData.value;
            }
        }

        console.log("Cache expired or not found.");
        return null;
    };
    setCache = (key, data, ttl) => {
        const now = new Date();
        const item = {
            value: data,
            expiry: now.getTime() + ttl * 60000, // TTL ในหน่วยนาที
        };
        console.log("Saving data to cache:", key, item);
        localStorage.setItem(key, JSON.stringify(item));
        console.log("Cached data after save:", localStorage.getItem(key));
    };
    // โหลดโลโก้ใหม่เบื้องหลัง พอโหลดเสร็จค่อย swap (ไม่กระพริบ ไม่ต้องใช้ loading)
    swapLogo = (url) => {
        if (!url || url === this.state.logoSrc) return;
        const img = new Image();
        img.onload = () => {
            this.setState({ logoSrc: url });
            try { window.localStorage.setItem('siteLogo', url); } catch (e) { }
        };
        img.src = url;
    };
    componentDidUpdate(prevProps, prevState) {
        if (prevState.logoimg !== this.state.logoimg) this.swapLogo(this.state.logoimg);
    }
    async componentDidMount() {
        document.body.className = 'x-transfer-website';
        NProgress.start();
        try {
            const pathname = window.location.pathname.split("/");
            const mainSettingKey = "mainSettingCache";
            const mainSettingTTL = 30 * 60 * 1000; // 30 นาที
            var token = localStorage.getItem('auth_token');
            var Playerid = null
            if (token != null) {
                var decoded = jwt_decode(token);
                Playerid = decoded.message.playerid;
            }
            const mainSettingCache = this.getCache(mainSettingKey, mainSettingTTL);

            if (mainSettingCache) {
                console.log("Using cached data for main setting");
                const data = mainSettingCache;

                document.title = data.tblsetting[0].title;
                const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                link.type = 'image/svg+xml';
                link.rel = 'icon';
                link.href = data.tblsetting[0].imglogo;
                document.getElementsByTagName('head')[0].appendChild(link);

                this.setState({
                    webname: data.tblsetting[0].Description,
                    logoimg: data.tblsetting[0].imglogo,
                    whellsetting: data.tblwheelsetting,
                    maxwithdrawstatus: data.tblcatagoryx[0].withdrawmax,
                    luckywheeldisplay: data.tblwheelsetting[0].status === 1,
                    linelink: data.message[1].value,
                    webnamex: data.message[7].value,
                    describemain: data.tblsetting[0].title,
                    System: data.tblcatagoryx[0].System,
                    cashoutSet: data.tblcashoutsetting[0],
                    inviteSet: data.tblinvitedsetting[0],
                    datas: data.message,
                    limit: { min: data.tblcatagoryx[0].limitdeposit, max: data.tblcatagoryx[0].maxdeposit },
                });
            } else {
                instance.post("/api/v1/mainsetting", {
                    System: Systems,
                    Playerid: Playerid,
                }).then((res) => {
                    if (res.data.status === 200) {
                        console.log("luckywheeldisplay", res.data);
                        const datas = res.data.message;
                        const min = res.data.tblcatagoryx[0].limitdeposit;
                        const max = res.data.tblcatagoryx[0].maxdeposit;
                        const maxwithdrawstatus = res.data.tblcatagoryx[0].withdrawmax;
                        const limit = { min, max };
                        const luckywheeldisplay = res.data.tblwheelsetting[0].status === 1;

                        document.title = res.data.tblsetting[0].title;
                        const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                        link.type = 'image/svg+xml';
                        link.rel = 'icon';
                        link.href = res.data.tblsetting[0].imglogo;
                        document.getElementsByTagName('head')[0].appendChild(link);

                        this.setState({
                            webname: res.data.tblsetting[0].Description,
                            logoimg: res.data.tblsetting[0].imglogo,
                            whellsetting: res.data.tblwheelsetting,
                            maxwithdrawstatus: maxwithdrawstatus,
                            luckywheeldisplay: luckywheeldisplay,
                            linelink: datas[1].value,
                            webnamex: datas[7].value,
                            describemain: res.data.tblsetting[0].title,
                            System: res.data.tblcatagoryx[0].System,
                            cashoutSet: res.data.tblcashoutsetting[0],
                            inviteSet: res.data.tblinvitedsetting[0],
                            datas: datas,
                            limit: limit,
                        });

                        this.setCache(mainSettingKey, res.data);
                    }
                });

            }

            if (pathname.length > 1) {
                console.log(pathname);
                if (pathname[1] == "casino") {
                    this.setState({ tabselect: 0, activeCategory: 'casino' });
                }
                else if (pathname[1] == "gamehit") {
                    this.setState({ tabselect: 0, activeCategory: 'hot' });
                }
                else if (pathname[1] == "fishing") {
                    this.setState({ tabselect: 0, activeCategory: 'fishing' });
                }
                else if (pathname[1] == "loss") {
                    this.setState({ tabselect: 25 });
                }
                else if (pathname[1] == "slot") {
                    this.setState({ tabselect: 0, activeCategory: 'slot' });
                }
                else if (pathname[1] == "register") {
                    this.setState({ tabselect: 22 });
                }
                else if (pathname[1] == "signin") {
                    this.setState({ tabselect: 23 });
                }
                else if (pathname[1] == "sport") {
                    this.setState({ tabselect: 0, activeCategory: 'sport' });
                }
                else if (pathname[1] == "event") {
                    this.setState({ tabselect: 16 });
                }
                else if (pathname[1] == "promotion") {
                    this.setState({ tabselect: 7 });
                }
                else if (pathname[1] == "compare") {
                    this.setState({ tabselect: 30 });
                }
                else if (pathname[1] == "instructions") {
                    this.setState({ tabselect: 28 });
                }
                else if (pathname[1] == "faq") {
                    this.setState({ tabselect: 29 });
                }
                else if (pathname[1] == "lotto") {
                    this.setState({ tabselect: 17 });
                }
                else if (pathname[1] == "withdraw") {
                    // console.log(1232323)
                    if (this.state.loginstate) {
                        this.setState({
                            tabselect: 2,
                        });
                    }
                    else {
                        this.setState({
                            tabselect: 0,
                        });
                    }
                }
                else if (pathname[1] == "deposit") {
                    if (this.state.loginstate) {
                        this.setState({
                            tabselect: 1,
                            tabselectdeposit: 1,
                        });
                    }
                    else {
                        this.setState({
                            tabselect: 0,
                        });
                    }
                }
                else if (pathname[1] == "statement") {
                    if (this.state.loginstate) {
                        this.setState({
                            tabselect: 3,
                        });
                    }
                    else {
                        this.setState({
                            tabselect: 0,
                        });
                    }
                }
                else if (pathname[1] == "profile") {
                    if (this.state.loginstate) {
                        this.setState({
                            tabselect: 8,
                        });
                    }
                    else {
                        this.setState({
                            tabselect: 0,
                        });
                    }
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/overview") {
                    this.setState({
                        tabselect: 4,
                        refer: 1
                    });
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/member") {
                    console.log(63855555);
                    this.setState({
                        tabselect: 4,
                        refer: 2
                    });
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/income-summary") {
                    this.setState({
                        tabselect: 4,
                        refer: 3
                    });
                }
                else if (pathname[1] + "/" + pathname[2] == "refer/share-network") {
                    this.setState({
                        tabselect: 4,
                        refer: 4
                    });
                }
                else if (pathname[1] == "rebate") {
                    this.setState({
                        tabselect: 5,
                    });
                }
                else if (pathname[1] == "promotion") {
                    this.setState({
                        tabselect: 7,
                    });
                }
                else if (pathname[1] == "listgameall") {
                    let check = await this.getgame(pathname[2], pathname[3]);
                    if (check) {
                        this.setState({
                            tabselect: 15,
                        });
                    }
                }
            }

            //   console.log(455, pathname[1] + "/" + pathname[2])


        }
        catch (error) {
            console.log(185222, error);
        }
        NProgress.done();
    }
    waitnotify = async () => {
        setTimeout(() => { console.log('World!') }, 5000)
    }
    notify = async (mode, msg) => {
        console.log(mode, msg);
        if (mode == "success") {
            await toast.success(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "warning") {
            await toast.warning(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "error") {
            await toast.error(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "info") {
            await toast.info(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        await this.waitnotify();
    }

    render() {
        const { isOpen, tabselect, logoimg, logoSrc, linelink, webnamex, webname, activeCategory } = this.state;

        const BASE = '/idea-bet.live/theme/1ufaai/';
        const IMG = BASE + 'build/images/';

        const navLinks = [
            { text: 'UFABET',       href: '/',          icon: 'ic-menu-home',                mobileOnly: false, external: false },
            { text: 'กิจกรรม',      href: '/event',     icon: 'ic-menu-event',               mobileOnly: false, external: false },
            { text: 'โปรโมชั่น',    href: '/promotion', icon: 'ic-menu-promotion',           mobileOnly: false, external: false },
            { text: 'แนะนำ',        href: '/instructions', icon: 'ic-menu-instruction',      mobileOnly: false, external: false },
            { text: 'เปรียบเทียบ',  href: '/compare',      icon: 'fire-animated',             mobileOnly: false, external: false },
            { text: 'คำถาม',        href: '/faq',          icon: 'ic-menu-guide',             mobileOnly: false, external: false },
            { text: 'ดูบอลสด',      href: linelink || '#', icon: 'ic-menu-ball-live',        mobileOnly: false, external: true  },
            { text: 'ทายผล',        href: '/',          icon: 'ic-menu-prediction-activity', mobileOnly: false, external: false },
            { text: 'แทงบอลยูฟ่า',  href: '/sport',     icon: 'ic-menu-betting-sport',       mobileOnly: true,  external: false },
            { text: 'คาสิโนยูฟ่า',  href: '/casino',    icon: 'ic-menu-betting-live-casino', mobileOnly: true,  external: false },
            { text: 'ยูฟ่าสล็อต',   href: '/slot',      icon: 'ic-menu-betting-slot',        mobileOnly: true,  external: false },
            { text: 'หวยยูฟ่า',     href: '/lotto',     icon: 'ic-menu-betting-lotto',       mobileOnly: true,  external: false },
        ];

        const categories = [
            { id: 'hot',      route: null,       icon: IMG + 'ic-ajax-menu-popular.png',  iconActive: IMG + 'ic-ajax-menu-popular-active.png',  th: 'กำลังฮิต',  en: 'Hot Games' },
            { id: 'sport',    route: '/sport',   icon: IMG + 'ic-ajax-menu-sport.png',    iconActive: IMG + 'ic-ajax-menu-sport-active.png',    th: 'กีฬา',       en: 'Sport'     },
            { id: 'casino',   route: '/casino',  icon: IMG + 'ic-ajax-menu-casino.png',   iconActive: IMG + 'ic-ajax-menu-casino-active.png',   th: 'คาสิโน',     en: 'Casino'    },
            { id: 'gamehall', route: null,       icon: IMG + 'ic-ajax-menu-hall.png',     iconActive: IMG + 'ic-ajax-menu-hall-active.png',     th: 'Game Hall',  en: 'Game Hall' },
            { id: 'card',     route: null,       icon: IMG + 'ic-ajax-menu-card.png',     iconActive: IMG + 'ic-ajax-menu-card-active.png',     th: 'ไพ่',        en: 'Card'      },
            { id: 'slot',     route: '/slot',    icon: IMG + 'ic-ajax-menu-slot.png',     iconActive: IMG + 'ic-ajax-menu-slot-active.png',     th: 'สล็อต',      en: 'Slot'      },
            { id: 'itp',      route: '/slot',    icon: IMG + 'ic-ajax-menu-itp-slot.png', iconActive: IMG + 'ic-ajax-menu-itp-slot-active.png', th: 'ITP สล๊อต', en: 'ITP Slot'  },
            { id: 'fishing',  route: '/fishing', icon: IMG + 'ic-ajax-menu-fishing.png',  iconActive: IMG + 'ic-ajax-menu-fishing-active.png',  th: 'ยิงปลา',     en: 'Fishing'   },
            { id: 'lotto',    route: '/lotto',   icon: IMG + 'ic-ajax-menu-lotto.png',    iconActive: IMG + 'ic-ajax-menu-lotto-active.png',    th: 'หวย',        en: 'Lotto'     },
            { id: 'esport',   route: '/sport',   icon: IMG + 'ic-ajax-menu-esport.png',   iconActive: IMG + 'ic-ajax-menu-esport-active.png',   th: 'อีสปอร์ต',  en: 'E-Sport'   },
        ];

        const gamesByCategory = {
            hot: [
                { img: IMG + 'ufa-provider-sport-desktop.png', name: 'กีฬา UFAgrand168', gameId: 'sport', partner: 'ufa' },
                { img: IMG + 'ufa-provider-ufa-casino.png', name: 'UFAgrand168 Casino', gameId: 'casino', partner: 'ufacasino' },
                { img: IMG + 'ufa-provider-pgsoft.png', name: 'PG SOFT', gameId: 'slot', partner: 'pg' },
                { img: IMG + 'ufa-provider-aesexy.png', name: 'AE Sexy', gameId: 'casino', partner: 'sexy' },
                { img: IMG + 'ufa-provider-jili.png', name: 'JILI', gameId: 'slot', partner: 'jili' },
                { img: IMG + 'ufa-provider-fa-chai.png', name: 'FA CHAI', gameId: 'gamehall', partner: 'fachai' },
                { img: IMG + 'ufa-provider-kingmidas.png', name: 'King Midas', gameId: 'gamehall', partner: 'kingmidas' },
                { img: IMG + 'ufa-provider-pok-deng.png', name: 'ป็อกเด้ง', gameId: 'card', partner: 'pokdeng' },
                { img: IMG + 'ufa-provider-sagame.png', name: 'SA Gaming', gameId: 'casino', partner: 'sa' },
            ],
            sport: [
                { img: IMG + 'ufa-provider-sport-desktop.png', name: 'กีฬา UFAgrand168', gameId: 'sport', partner: 'ufa' },
                { img: IMG + 'ufa-provider-kingmidas-sport.png', name: 'King Midas Sport', gameId: 'sport', partner: 'kingmidas' },
            ],
            casino: [
                { img: IMG + 'ufa-provider-ufa-casino.png', name: 'UFAgrand168 Casino', gameId: 'casino', partner: 'ufacasino' },
                { img: IMG + 'ufa-provider-aesexy.png', name: 'AE Sexy', gameId: 'casino', partner: 'sexy' },
                { img: IMG + 'ufa-provider-sagame.png', name: 'SA Gaming', gameId: 'casino', partner: 'sa' },
            ],
            gamehall: [
                { img: IMG + 'ufa-provider-fa-chai.png', name: 'FA CHAI', gameId: 'gamehall', partner: 'fachai' },
                { img: IMG + 'ufa-provider-kingmidas.png', name: 'King Midas', gameId: 'gamehall', partner: 'kingmidas' },
            ],
            card: [
                { img: IMG + 'ufa-provider-pok-deng.png', name: 'ป็อกเด้ง', gameId: 'card', partner: 'pokdeng' },
                { img: IMG + 'ufa-provider-aesexy-thai-hilo.png', name: 'Thai Hi-Lo', gameId: 'card', partner: 'hilo' },
            ],
            slot: [
                { img: IMG + 'ufa-provider-pgsoft.png', name: 'PG SOFT', gameId: 'slot', partner: 'pg' },
                { img: IMG + 'ufa-provider-jili.png', name: 'JILI', gameId: 'slot', partner: 'jili' },
                { img: IMG + 'ufa-provider-aug-slot.png', name: 'AUG Slot', gameId: 'slot', partner: 'aug' },
            ],
            itp: [
                { img: IMG + 'ufa-provider-aug-slot.png', name: 'ITP Slot', gameId: 'slot', partner: 'itp' },
            ],
            fishing: [
                { img: IMG + 'ufa-provider-jili.png', name: 'JILI Fishing', gameId: 'fishing', partner: 'jili' },
                { img: IMG + 'ufa-provider-fa-chai.png', name: 'FA CHAI Fish', gameId: 'fishing', partner: 'fachai' },
            ],
        };
        const currentGames = gamesByCategory[activeCategory] || gamesByCategory.hot;

        // Banner slider: 3 slides visible (matching original 320px×3=960px layout)
        const bannerSettings = {
            dots: true, infinite: true, speed: 500,
            slidesToShow: 3, slidesToScroll: 1,
            autoplay: true, autoplaySpeed: 4000,
            arrows: false,
            responsive: [{ breakpoint: 768, settings: { slidesToShow: 1 } }]
        };

        const features = [
            { label: 'SPORT BETTING', iconMod: '-sport', title: 'แทงบอลออนไลน์', title2: 'UFAgrand168 แทงบอล', desc: 'เว็บบอล เจ้าแรกยอดนิยมในไทย เล่นง่าย ราคาดี มีให้เล่นทุกลีก UFAgrand168', btnText: 'แทงบอล', img: IMG + 'ufa-game-type-ic-index-sport.png', onClick: (e) => this.checkurl(e, '/sport') },
            { label: 'LIVE CASINO', iconMod: '-live-casino', title: 'คาสิโนออนไลน์', title2: 'คาสิโนสด UFAgrand168', desc: 'เว็บพนัน UFAgrand168 ที่ครอบคลุม นิยมที่สุด กับค่ายคาสิโน ชั้นนำมากมาย', btnText: 'คาสิโนสด', img: IMG + 'ufa-game-type-ic-index-live-casino.png', onClick: (e) => this.checkurl(e, '/casino') },
            { label: 'SLOT', iconMod: '-slot', title: 'สล็อต และ เกม', title2: 'คาสิโน UFAgrand168', desc: 'สล็อตออนไลน์ ภาพสวย ไม่หลุด เล่นได้ทั้งคอมมือถือ Jackpot เท่าไหร่ก็จ่าย', btnText: 'สล็อตออนไลน์', img: IMG + 'ufa-game-type-ic-index-slot.png', onClick: (e) => this.checkurl(e, '/slot') },
            { label: 'LOTTO', iconMod: '-lotto', title: 'หวยออนไลน์', title2: 'กับ UFAgrand168', desc: 'เจ้าแรกที่นำหวย เข้าสู่เว็บพนันออนไลน์ คู่คนไทย ทั้งหวยทั้งUFAgrand168 ไม่มีอั้น!', btnText: 'หวยออนไลน์', img: IMG + 'ufa-game-type-ic-index-lotto.png', onClick: (e) => this.checkurl(e, '/lotto') },
        ];

        const articles = [
            { title: '10รับ100 โปรสล็อตทุนน้อย ล่าสุด 2025 ถอนได้จริง', img: '0166832fbfd306f324658ce2b45e3d25.png' },
            { title: 'ฝาก 10 รับ 100 ทํา ยอด 300 ถอน ได้ 100 โปรโมชั่นแตกง่าย', img: '06a099ef044aa39f7a039bf6f522751a.png' },
            { title: '10 รับ 100 ทํา 400ถอน200 ล่าสุด 2025 | โปรสล็อตทุนน้อย ถอนได้จริง', img: '1256fe1aba1d02308b9e7ad8ff12c44a.png' },
            { title: '10รับ100 ทํา 300 ถอน200 ล่าสุด 2025 | ถอนได้จริง ไม่ต้องแชร์', img: 'af22e296edc82da34f35585c293e269d.png' },
            { title: 'UFAgrand168เว็บพนันบอลบริการ 24 ชั่วโมงถ่ายทอดสดสมจริงที่ดีที่สุด', img: '0f5c1c352902c93ca78edc8ac72a3b17.png' },
            { title: 'UFAgrand168ลู่ทางทำกำไรอย่างเต็มรูปแบบการันตีความคุ้มค่าขั้นสุด', img: '7abb873c775b9ddee1eaf6f884ec5119.png' },
            { title: 'UFAgrand168เว็บพนันออนไลน์ที่พร้อมบริการที่ตอบโจทย์ที่สุด', img: '22400f7650190ab47cc2aeff46006b6c.png' },
            { title: 'UFAgrand168แหล่งรวมความบันเทิงกีฬาออนไลน์ที่ได้รับความนิยมอันดับ 1', img: '548bdfa21f0bdf4eb54c8a22da136470.png' },
        ];

        // Game carousel thumbnails (ขนาด 140×66px ตามต้นฉบับ)
        const gameThumbs = [
            BASE + 'media/cache/strip/202408/block/ebdf4078d69ae43702b335224288fcc3.png',
            BASE + 'media/cache/strip/202408/block/808b95a6e777fea89f26531d7352e07b.png',
            BASE + 'media/cache/strip/202408/block/21afe51e4badd8951862728205bc5063.png',
            BASE + 'media/cache/strip/202408/block/2f84ceb7dafa5271c1bbebe6ad8058e8.png',
            BASE + 'media/cache/strip/202408/block/ebdf4078d69ae43702b335224288fcc3.png',
            BASE + 'media/cache/strip/202408/block/808b95a6e777fea89f26531d7352e07b.png',
            BASE + 'media/cache/strip/202408/block/21afe51e4badd8951862728205bc5063.png',
            BASE + 'media/cache/strip/202408/block/2f84ceb7dafa5271c1bbebe6ad8058e8.png',
        ];

        return (
            <>
                {/* CSS */}
                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.2/css/regular.min.css" />
                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.2/css/solid.min.css" />
                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.2/css/brands.min.css" />
                <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.2/css/fontawesome.min.css" />
                <link rel="stylesheet" href="/idea-bet.live/theme/1ufaai/style.css" />

                {/* ======================== NAVBAR ======================== */}
                {/* position absolute: เมนูโปร่งใสทับพื้นหลังสนาม + ไม่เลื่อนตามตอน scroll (ไม่ fixed) */}
                <nav className="x-header navbar -anon -with-sidebar" style={{ position: 'absolute', top: 0, left: 0, width: '100%', zIndex: 50 }}>
                    <div className="container -container-wrapper" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                        {/* Row 1: hamburger + logo + nav links */}
                        <div id="headerBrand" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', flex: 1 }}>
                            <div className="x-hamburger js-hamburger-menu-toggle -with-menu-center" onClick={this.toggleSidebar}>
                                <span /><span /><span />
                            </div>
                            <a className="navbar-brand" href="/" onClick={(e) => { e.preventDefault(); this.checkurl(e, '/'); }}>
                                <img className="-logo" src={logoSrc || (IMG + 'logo.png')} alt="UFAgrand168" style={{ maxHeight: '50px' }} />
                            </a>
                            <div className="-menu-wrapper" style={{ flex: 1 }}>
                                <div className="x-menus-container -hamburger -with-menu-center -anon -desktop">
                                    <ul className="navbar-nav -list">
                                        {navLinks.filter(l => !l.mobileOnly).map((link, i) => (
                                            <li key={i} className={`nav-item -list-item${i === 0 ? ' -active' : ''}`}>
                                                <a className={`nav-link -list-link${i === 0 ? ' -active x-bg-position-center' : ''}`}
                                                    href={link.href}
                                                    onClick={(e) => { e.preventDefault(); if (link.external) { window.open(link.href, '_blank', 'noopener,noreferrer'); } else { this.checkurl(e, link.href); } }}>
                                                    <picture>
                                                        <source type="image/webp" srcSet={IMG + link.icon + '.webp'} />
                                                        <source type="image/png" srcSet={IMG + link.icon + '.png'} />
                                                        <img alt={link.text} className="-icon" width={100} height={100} src={IMG + link.icon + '.png'} />
                                                    </picture>
                                                    <span className="-text">{link.text}</span>
                                                    <span className="-text -mobile">{link.text}</span>
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        {/* Row 2: Login button - gold gradient, right side */}
                        <div className="navbar-nav ml-auto" style={{ flexShrink: 0 }}>
                            <div className="d-flex">
                                <button
                                    className="btn -header-btn -header-login-btn -ufabet"
                                    style={{
                                        background: 'radial-gradient(100% 100% at 50% 0px, rgb(255,237,175) 23.27%, rgb(169,133,43) 100%)',
                                        color: '#333', borderRadius: '30px', width: '150px',
                                        padding: '6px 16px', border: 'none', cursor: 'pointer',
                                        fontWeight: '600', fontSize: '14px', whiteSpace: 'nowrap'
                                    }}
                                    onClick={() => { window.location.href = '/signin'; }}>
                                    <span className="-text">เข้าสู่ระบบ</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </nav>

                {/* ======================== SIDEBAR ======================== */}
                <div className={`x-menu-account-sidebar${isOpen ? ' -open' : ''}`}
                    style={{ display: isOpen ? 'block' : 'none', position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999 }}>
                    <div className="-sidebar-wrapper"
                        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: '#1a1a1a', overflowY: 'auto', zIndex: 1 }}>
                        {/* Header */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', borderBottom: '1px solid #333' }}>
                            <img src={logoSrc || (IMG + 'logo.png')} alt="logo" style={{ height: '36px' }} />
                            <button onClick={this.toggleSidebar} style={{ background: 'none', border: 'none', color: '#fff', fontSize: '20px', cursor: 'pointer' }}>✕</button>
                        </div>
                        {/* Grid menu */}
                        <ul style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', padding: '12px', margin: 0, listStyle: 'none' }}>
                            {navLinks.map((link, i) => (
                                <li key={i}>
                                    <a href={link.href}
                                        onClick={(e) => { e.preventDefault(); this.toggleSidebar(); if (link.external) { window.open(link.href, '_blank', 'noopener,noreferrer'); } else { this.checkurl(e, link.href); } }}
                                        style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', background: '#2a2a2a', borderRadius: '10px', padding: '12px 8px', textDecoration: 'none', color: '#fff', fontSize: '13px', fontWeight: '500', gap: '6px', minHeight: '90px' }}>
                                        <picture>
                                            <source type="image/webp" srcSet={IMG + link.icon + '.webp'} />
                                            <source type="image/png" srcSet={IMG + link.icon + '.png'} />
                                            <img alt={link.text} width={56} height={56} src={IMG + link.icon + '.png'} style={{ objectFit: 'contain' }} />
                                        </picture>
                                        <span>{link.text}</span>
                                    </a>
                                </li>
                            ))}
                        </ul>
                        <div className="-sidebar-login">
                            <a className="btn -btn-login" href="#" onClick={(e) => { e.preventDefault(); window.location.href = webnamex || '/home'; }}>
                                เข้าสู่ระบบ
                            </a>
                            <a className="btn -btn-register" href="#" onClick={(e) => { e.preventDefault(); window.location.href = (webnamex || '') + '/register'; }}>
                                สมัครสมาชิก
                            </a>
                        </div>
                    </div>
                </div>

                {/* ======================== MAIN CONTENT ======================== */}
                <div id="main__content">

                    {/* ======================== CONTACT US WIDGET ======================== */}
                    <div className="x-wrapper-right-container">
                        <div className="x-contact-us-default-hidden">
                            <button className="btn -btn-toggle js-btn-toggle">
                                <picture>
                                    <img className="-ic img-fluid" src={IMG + 'ic-contact-us.png'} alt="contact" />
                                </picture>
                                <span className="-text-normal">ติดต่อเรา</span>
                            </button>
                            <div className="-list-wrapper">
                                <div className="card card-body">
                                    <button className="btn -btn-close js-btn-toggle"><span className="-text-close">ปิด</span><i className="fas fa-times -ic" /></button>
                                    <a className="-link-item" href={linelink || '#'}>
                                        <img className="img-fluid -img" src={IMG + 'contact-us.png'} alt="LINE" />
                                    </a>
                                    <a className="-link-item mt-2 mt-lg-3" href="#">
                                        <img className="img-fluid -img" src={IMG + 'contact-us-telegram.png'} alt="Telegram" />
                                    </a>
                                    <a className="-link-item mt-2 mt-lg-3" href="#">
                                        <img className="img-fluid -img" src={IMG + 'contact-us-facebook.png'} alt="Facebook" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ======================== SUB-PAGE TABS ======================== */}
                    {tabselect === 10 && <Casino checkurl={this.checkurl} webnamex={webnamex} linelink={linelink} logoimg={logoimg} />}
                    {tabselect === 12 && <Fishing checkurl={this.checkurl} webnamex={webnamex} linelink={linelink} logoimg={logoimg} />}
                    {tabselect === 13 && <Slot checkurl={this.checkurl} webnamex={webnamex} linelink={linelink} logoimg={logoimg} />}
                    {tabselect === 14 && <Sport checkurl={this.checkurl} webnamex={webnamex} linelink={linelink} logoimg={logoimg} />}
                    {tabselect === 7  && <PromotionsPage checkurl={this.checkurl} webnamex={webnamex} linelink={linelink} logoimg={logoimg} />}
                    {tabselect === 16 && <EventPage />}
                    {tabselect === 28 && <Instructions />}
                    {tabselect === 29 && <FaqPage />}
                    {tabselect === 30 && <ComparePage />}

                    {/* ======================== LANDING PAGE (tabselect === 0) ======================== */}
                    {tabselect === 0 && (
                        <section className="x-index-cover-container -slide-banner -anon x-bg-position-center lazyloaded"
                            style={{
                                backgroundImage: `url(${IMG}bg_index.webp)`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                                paddingTop: '60px'
                            }}>

                            {/* Hero Banner Slider */}
                            <div className="x-homepage-banner-container -anon">
                                <div className="container px-0">
                                    <Banner slidesToShow={3} marginTop="0px" />
                                </div>
                            </div>

                            {/* Game Thumbnail Carousel — 140×66px ตามต้นฉบับ */}
                            <div className="x-banner-gamer-slider" style={{ padding: '6px 0' }}>
                                <div className="container -custom-container">
                                    <div className="-slider-wrapper -single" style={{ height: '66px', overflow: 'hidden' }}>
                                        <Slider {...settings}>
                                            {gameThumbs.map((src, i) => (
                                                <div key={i} style={{ padding: '0 6px' }}>
                                                    <img
                                                        className="img-fluid"
                                                        src={src}
                                                        alt="game thumb"
                                                        style={{ height: '66px', width: '140px', objectFit: 'cover', borderRadius: '6px', display: 'block' }}
                                                    />
                                                </div>
                                            ))}
                                        </Slider>
                                    </div>
                                </div>
                            </div>

                            {/* Heading */}
                            <div className="-heading-title">
                                <div className="container">
                                    <strong className="-title">UFAgrand168 แทงบอลออนไลน์มั่นคงที่สุด</strong>
                                </div>
                            </div>

                            {/* Game Categories + Grid */}
                            <div className="-ufa-menu-provider-wrapper">
                                <div className="container">
                                    <div className="x-ufa-menu-provider">
                                        {/* Left Sidebar */}
                                        <div className="-side-menu-wrapper">
                                            <div className="js-sticky-widget">
                                                <ul id="myTab" className="nav nav-tabs -tab-menu-list">
                                                    {categories.map((cat) => {
                                                        const isActive = activeCategory === cat.id;
                                                        const isMobileView = window.innerWidth < 768;
                                                        return (
                                                            <li key={cat.id} className={`nav-item${isActive ? ' -active' : ''}`} style={{ marginBottom: '4px' }}>
                                                                <a
                                                                    className={`nav-link${isActive ? ' active' : ''}`}
                                                                    onClick={() => this.setState({ activeCategory: cat.id })}
                                                                    style={{
                                                                        background: isActive ? 'linear-gradient(rgb(231,211,157), rgb(177,149,96))' : 'linear-gradient(rgb(57,57,57), rgb(41,41,41))',
                                                                        borderRadius: '14px',
                                                                        padding: isMobileView ? '8px 6px' : '10px 12px',
                                                                        display: 'block',
                                                                        cursor: 'pointer',
                                                                        textDecoration: 'none'
                                                                    }}
                                                                >
                                                                    <div className="-button-inner-wrapper" style={{ display: 'flex', flexDirection: isMobileView ? 'column' : 'row', alignItems: 'center', gap: isMobileView ? '4px' : '10px' }}>
                                                                        <picture>
                                                                            <img className="img-fluid -ic-menu" src={isActive ? cat.iconActive : cat.icon} alt={cat.th}
                                                                                style={{ width: isMobileView ? '32px' : '38px', height: isMobileView ? '32px' : '38px', objectFit: 'contain', flexShrink: 0, display: 'block' }} />
                                                                        </picture>
                                                                        <div className="-text-provider-wrapper" style={{ overflow: 'hidden', textAlign: isMobileView ? 'center' : 'left' }}>
                                                                            <div style={{ color: isActive ? '#333' : '#fff', fontWeight: '600', fontSize: isMobileView ? '11px' : '13px', lineHeight: '1.3', whiteSpace: 'nowrap' }}>{cat.th}</div>
                                                                            {!isMobileView && <div style={{ color: isActive ? '#555' : 'rgba(255,255,255,0.5)', fontSize: '11px' }}>{cat.en}</div>}
                                                                        </div>
                                                                    </div>
                                                                </a>
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                            </div>
                                        </div>
                                        {/* Right Game Grid */}
                                        <div id="myTabContent" className="tab-content -tab-content">
                                            <div className="tab-pane fade show active">
                                                <ul className="nav -list">
                                                    {currentGames.map((game, i) => (
                                                        <li key={i} className="nav-item -list-item"
                                                            style={{ position: 'relative', overflow: 'hidden', borderRadius: '8px', listStyle: 'none', cursor: 'pointer' }}
                                                            onClick={(e) => { e.preventDefault(); window.location.href = webnamex || '/'; }}>
                                                            {/* การ์ดเกม: รูปเต็มใบเหมือน reference (ไม่มี <a> + พื้นหลังเทา) */}
                                                            <picture>
                                                                <source type="image/webp" srcSet={game.img.replace(/\.png$/i, '.webp')} />
                                                                <img className="img-fluid -img -cover-img" src={game.img} alt={game.name}
                                                                    style={{ width: '100%', height: 'auto', objectFit: 'cover', display: 'block', borderRadius: '8px' }} />
                                                            </picture>
                                                            <div className="-overlay"
                                                                style={{
                                                                    position: 'absolute', top: 0, left: 0, width: '100%', height: '100%',
                                                                    background: 'linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 60%)',
                                                                    display: 'flex', alignItems: 'flex-end', justifyContent: 'center',
                                                                    paddingBottom: '12px', opacity: 0, transition: 'opacity 0.3s',
                                                                    borderRadius: '8px'
                                                                }}
                                                                onMouseEnter={e => e.currentTarget.style.opacity = '1'}
                                                                onMouseLeave={e => e.currentTarget.style.opacity = '0'}>
                                                                <button className="btn -btn-play"
                                                                    style={{
                                                                        background: 'linear-gradient(rgb(231,211,157), rgb(177,149,96))',
                                                                        color: '#333', borderRadius: '30px', padding: '6px 18px',
                                                                        border: 'none', fontWeight: '700', cursor: 'pointer', fontSize: '13px'
                                                                    }}>
                                                                    <span>เล่นเลย</span>
                                                                </button>
                                                            </div>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* SEO Intro */}
                            <div className="-heading-title -sub">
                                <div className="container">
                                    <h1 className="-pre-sub-title">UFAgrand168 เว็บตรง อันดับ 1 สมัครง่าย จ่ายจริง ครบทุกการเดิมพัน</h1>
                                    <p className="-sub-title">
                                        ในยุคที่เทคโนโลยีก้าวหน้า <span className="text-primary">UFAgrand168</span> ได้รับความนิยมอย่างแพร่หลาย
                                        โดยเฉพาะในหมวดของ แทงบอลออนไลน์{' '}
                                        <span className="text-primary">UFAgrand168 เข้าสู่ระบบ</span> ด้วยระบบฝาก-ถอนออโต้ที่รวดเร็ว มั่นคง ปลอดภัย
                                        เปิดให้บริการตลอด 24 ชั่วโมง สมัครง่ายเพียงเบอร์โทรศัพท์ ไม่ต้องแอดไลน์
                                    </p>
                                </div>
                            </div>

                        </section>
                    )}

                    {/* ======================== SECTIONS (tabselect === 0 only) ======================== */}
                    {tabselect === 0 && (
                        <>
                            {/* Feature Section */}
                            <section className="x-index-feature-container">
                                <div className="x-ufa-game-types-component -in-banner-slider">
                                    <div className="container -games-container">
                                        <div className="row -row-inner-wrapper">
                                            {features.map((f, i) => (
                                                <div key={i} className="-col-wrapper -column-number-4 animated fadeInUp">
                                                    <div className="-box-wrapper">
                                                        <div className="-icon-wrapper">
                                                            <img className={`img-fluid -icon ${f.iconMod}`} src={f.img} alt={f.label} />
                                                        </div>
                                                        <div className="-content-wrapper">
                                                            <div className="-title">{f.label}</div>
                                                            <h2 className="-sub-title">{f.title}<br />{f.title2}</h2>
                                                            <p className="-content">{f.desc}</p>
                                                            <a className="-btn-play" onClick={f.onClick} style={{ cursor: 'pointer' }}>{f.btnText}</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </section>

                            {/* How-To / Middle Content Section */}
                            <section className="x-ufa-middle-content-component x-bg-position-bottom" style={{ backgroundImage: `url(${IMG}ufa-middle-content-bg.png)` }}>
                                <div className="-middle-container">
                                    <div className="container -half-content">
                                        {/* Row 1: Logo + Heading */}
                                        <div className="row -middle-container-row-1">
                                            <div className="col-12 col-lg-6 -left-container-top -img-container">
                                                <img alt="UFAgrand168 logo" className="img-fluid -logo" src={logoimg || IMG + 'logo.png'} />
                                            </div>
                                            <div className="col-12 col-lg-6 -right-container-top">
                                                <h3 className="-text-title">ฝาก-ถอน ออโต้ โปรแรงสุดในไทย<br />อัพเกรดใหม่ New UFAgrand168 ระบบไวกว่าเดิม</h3>
                                            </div>
                                        </div>
                                        {/* Row 2: Banner + Text List + Casino Logos */}
                                        <div className="row -middle-container-row-2">
                                            <div className="col-12 col-lg-6 -left-container-bottom">
                                                <img alt="UFAgrand168 banner" className="img-fluid -banner-img" src={IMG + 'ufa-middle-content-banner.png'} />
                                            </div>
                                            <div className="col-12 col-lg-6 -right-container-bottom">
                                                <div className="x-text-lists-component -half-content">
                                                    <ul className="navbar-nav">
                                                        {[
                                                            'สมัครง่าย ไม่ต้องแอดไลน์',
                                                            'ล็อคอินด้วยเบอร์โทรศัพท์ไม่ต้องจำยูส',
                                                            'อยู่ในระบบตลอด ไม่ต้องล็อคอินทุกครั้ง',
                                                            'การันตี ฝาก-ถอน ออโต้เจ้าแรก ที่ใช้ได้จริง',
                                                            'เล่นหนัก ถอนได้ไม่อั้น ไม่จำกัด สูงสุดต่อวัน',
                                                            'ปรับไม้การเดิมพันได้สูงสุดถึง 200,000/ไม้',
                                                            'ทีมงานดูแลอย่างเป็นกันเองตลอด 24 ชั่วโมง',
                                                        ].map((text, i) => (
                                                            <li key={i} className="nav-item">
                                                                <img alt="icon" className="img-fluid -icon-img" src={IMG + 'ufa-middle-content-text-list-icon.png'} width="32" height="32" />
                                                                <span className="-text">{text}</span>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                                {/* Casino Lobby Logos */}
                                                <div className="x-ufa-lobby-logo-component -half-content">
                                                    <ul className="navbar-nav">
                                                        {[
                                                            { img: '1UFABET-logo-circle-notext.png', label: 'UFAgrand168' },
                                                            { img: 'sexy-bac-02-logo-circle-notext.png', label: 'เซ็กซี่ บาคาร่า' },
                                                            { img: 'sa-gaming-02-logo-circle-notext.png', label: 'SA บาคาร่า' },
                                                            { img: 'joker-logo-circle-notext.png', label: 'สลอตโจ๊กเกอร์' },
                                                            { img: 'gd-casino-logo-circle-notext.png', label: 'GD คาสิโน' },
                                                            { img: 'muay-step-logo-circle-notext.png', label: 'มวยสเตป' },
                                                            { img: 'lotto-logo-circle-notext.png', label: 'หวยรายวัน' },
                                                            { img: 'fishing-logo-circle-notext.png', label: 'ยิงปลา' },
                                                            { img: 'kai-chon-logo-circle-notext.png', label: 'ไก่ชน' },
                                                            { img: 'kingmaker-logo-circle-notext.png', label: 'เกมส์ไฮโล' },
                                                        ].map((c, i) => (
                                                            <li key={i} className="nav-item">
                                                                <img alt={c.label} className="img-fluid -casino-logo" src={IMG + c.img} width="100" height="100" />
                                                                <div className="-text-title">{c.label}</div>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            {/* SEO Content Section — markup + เนื้อหาเต็มตาม reference (x-content-banner-vertical-component) */}
                            {(() => {
                                const seoBlocks = [
                                    { t: 'h2', cls: 'f-4 text-primary', txt: 'UFAgrand168 เข้าสู่ระบบ แทงบอลออนไลน์ กับ UFAgrand168' },
                                    { t: 'p', txt: 'UFAgrand168 เข้าสู่ระบบ เริ่มต้นจากการเป็นเว็บไซต์แทงบอลออนไลน์ที่มุ่งเน้นบริการผู้เล่นในเอเชียตะวันออกเฉียงใต้ UFAgrand168 ด้วยระบบการเดิมพันที่เข้าใจง่าย อัตราต่อรองที่ยุติธรรม และระบบฝาก-ถอนที่รวดเร็ว จนกลายเป็นที่นิยมในเวลาไม่นาน' },
                                    { t: 'p', txt: 'UFAgrand168 คือหนึ่งในพันธมิตรที่ได้รับการแต่งตั้งอย่างเป็นทางการจาก UFAgrand168 โดยมีจุดมุ่งหมายเพื่อขยายบริการในตลาดไทย รองรับนักเดิมพันที่ต้องการความสะดวกและปลอดภัยมากยิ่งขึ้น ด้วยระบบการให้บริการที่มีประสิทธิภาพ และทีมงานที่ให้การสนับสนุนตลอด 24 ชั่วโมง' },
                                    { t: 'h2', cls: 'f-4 text-primary', txt: 'สมัคร UFAgrand168 กับ UFAgrand168 ง่ายใน 3 ขั้นตอน' },
                                    { t: 'ol', items: ['คลิกปุ่มสมัครสมาชิก ที่หน้าเว็บไซต์ UFAgrand168', 'กรอกข้อมูล เบอร์โทรศัพท์ ตั้งรหัสผ่าน และยืนยัน OTP', 'เข้าสู่ระบบ และฝากเงินเพื่อเริ่มเดิมพันได้ทันที'] },
                                    { t: 'p', txt: 'ระบบสมัครสมาชิกของเราเป็นแบบอัตโนมัติ 100% ใช้เวลาไม่เกิน 1 นาที และไม่มีขั้นตอนยุ่งยาก ไม่ต้องแอดไลน์ ไม่ต้องส่งสลิป' },
                                    { t: 'h2', cls: 'f-4 text-primary', txt: 'ทางเข้า UFAgrand168 ล่าสุดผ่าน UFAgrand168' },
                                    { t: 'p', txt: 'หมดปัญหาลิงก์เสีย หาทางเข้าไม่ได้ เพราะ UFAgrand168 อัปเดตทางเข้า UFAgrand168 ทุกวัน พร้อมให้คุณเข้าสู่ระบบได้ทันที ทั้งผ่านมือถือและคอมพิวเตอร์ รองรับทุกแพลตฟอร์ม ไม่ต้องโหลดแอป' },
                                    { t: 'h2', cls: 'f-4 text-primary', txt: 'จุดเด่นของ UFAgrand168 ที่ทำให้แตกต่าง' },
                                    { t: 'h3', cls: 'f-5 text-primary', txt: 'UFAgrand168 เข้าสู่ระบบ ระบบฝากถอนอัตโนมัติ ไม่มีขั้นต่ำ' },
                                    { t: 'p', txt: '- จุดเด่นอย่างหนึ่งที่ทำให้ UFAgrand168 ได้รับความนิยมอย่างต่อเนื่องคือระบบฝากถอนที่รวดเร็ว ผู้เล่นสามารถทำธุรกรรมได้ภายในไม่กี่วินาที และไม่จำเป็นต้องแจ้งสลิปให้ยุ่งยาก รองรับทั้ง Mobile Banking และวอลเล็ต' },
                                    { t: 'h3', cls: 'f-5 text-primary', txt: 'ระบบฝากถอนอัตโนมัติ ไม่มีขั้นต่ำ' },
                                    { t: 'p', txt: '- ไม่ว่าคุณจะใช้สมาร์ตโฟน แท็บเล็ต หรือคอมพิวเตอร์ คุณสามารถเข้าใช้งานเว็บไซต์ UFAgrand168 ได้อย่างสะดวกสบาย รองรับทั้งระบบ iOS และ Android ตัวเว็บถูกออกแบบมาให้โหลดไว ตอบสนองไว และใช้งานง่ายแม้เป็นมือใหม่' },
                                    { t: 'h3', cls: 'f-5 text-primary', txt: 'ครบทุกลีก ครบทุกรูปแบบการแทงบอล UFAgrand168' },
                                    { t: 'p', txt: '- สำหรับคอกีฬาโดยเฉพาะสาย แทงบอลออนไลน์ คุณสามารถเดิมพันได้ครบทั้งบอลเดี่ยว บอลสเต็ป แทงสูงต่ำ แทงใบเหลือง-ใบแดง รวมถึงตลาดพิเศษอื่นๆ เช่น ผู้ยิงประตูแรก ทีมที่ได้เตะมุมมากกว่า ฯลฯ' },
                                    { t: 'h2', cls: 'f-4 text-primary', txt: 'UFAgrand168 ประตูสู่โลกของการเดิมพันออนไลน์ที่ดีที่สุด' },
                                    { t: 'p', txt: 'UFAgrand168 เว็บตรง โดยไม่ผ่านเอเย่นต์? คำตอบอยู่ที่ความปลอดภัยและความสะดวกในการทำธุรกรรม การเล่นผ่าน เว็บ UFAgrand168 ที่ดีที่สุด โดยตรงจะทำให้คุณได้รับประสบการณ์การเดิมพันที่ไม่ผ่านตัวกลาง มีความมั่นคงทางการเงินสูง และสามารถรับโบนัส UFAgrand168 ได้เต็มที่ หนึ่งในเหตุผลที่ทำให้ UFAgrand168 เป็นที่นิยมในกลุ่มนักเดิมพันคือ ระบบ ฝากถอน UFAgrand168 ที่รวดเร็วและปลอดภัย โดยเฉพาะระบบการฝาก-ถอนออโต้ที่สามารถทำได้ตลอด 24 ชั่วโมง ทำให้คุณไม่พลาดโอกาสในการเดิมพันที่สำคัญ' },
                                    { t: 'h3', cls: 'f-4 text-primary', txt: 'วิธี สมัคร UFAgrand168 ขั้นตอนง่ายๆ ในการสมัครสมาชิก' },
                                    { t: 'p', txt: 'การ สมัคร UFAgrand168 ผ่านเว็บไซต์หรือมือถือไม่ยุ่งยากอย่างที่คิด คุณสามารถสมัครสมาชิกได้โดยตรงผ่านหน้าเว็บไซต์ของ UFAgrand168 หรือใช้แอปพลิเคชันมือถือที่รองรับการเล่นทั้งในระบบ iOS และ Android โดยมีขั้นตอนดังนี้:' },
                                    { t: 'ol', items: ['ไปที่หน้าเว็บ UFAgrand168 หรือดาวน์โหลดแอปพลิเคชัน', 'กรอกข้อมูลส่วนตัว เช่น ชื่อ, เบอร์โทรศัพท์, และข้อมูลการเงิน', 'ยืนยันตัวตน เพื่อความปลอดภัยของบัญชีผู้ใช้งาน UFAgrand168 เข้าสู่ระบบ', 'ฝากเงินเพื่อเริ่มเดิมพัน โดยคุณสามารถเลือกฝากเงินผ่านช่องทางที่สะดวกและรวดเร็ว'] },
                                    { t: 'h3', cls: 'f-4 text-primary', txt: 'วิธีสมัคร UFAgrand168 ขั้นตอนง่ายๆ ในการสมัครสมาชิก' },
                                    { t: 'p', txt: 'การเล่น UFAgrand168 สามารถเริ่มต้นได้ง่ายๆ แม้จะมีเงินทุนน้อย เพราะ UFAgrand168 มี UFAgrand168 ฝากขั้นต่ำ 50 ที่ช่วยให้ผู้เล่นสามารถเริ่มเดิมพันได้โดยไม่ต้องกังวลเกี่ยวกับทุนการเล่น คุณสามารถเริ่มต้นกับการเล่น แทงบอลออนไลน์ UFAgrand168 หรือ คาสิโนออนไลน์ UFAgrand168 ด้วยเงินลงทุนที่ต่ำ' },
                                    { t: 'h2', cls: 'f-4 text-primary', txt: 'ข้อดีและข้อเสียของการเล่น UFAgrand168' },
                                    { t: 'h3', cls: 'f-5 text-primary text-left', txt: 'ข้อดีของ UFAgrand168' },
                                    { t: 'ol', items: ['ความหลากหลายของเกมและการเดิมพัน: UFAgrand168 มีการให้บริการการเดิมพันที่หลากหลาย ไม่ว่าจะเป็นการแทงบอลออนไลน์, คาสิโนออนไลน์, สล็อตออนไลน์, บาคาร่า, ไฮโล, หรือแม้กระทั่งการเดิมพันในกีฬาอื่นๆ เช่น มวยออนไลน์ ซึ่งทำให้ผู้เล่นสามารถเลือกเดิมพันในสิ่งที่ตนเองชื่นชอบได้ตามต้องการ', 'บริการที่ดีและรวดเร็ว: UFAgrand168 มีการให้บริการลูกค้าตลอด 24 ชั่วโมง ผ่านทางแชทสด, โทรศัพท์, หรือช่องทางอื่นๆ ซึ่งทำให้ผู้เล่นสามารถรับความช่วยเหลือหรือคำแนะนำได้ทุกเมื่อที่ต้องการ', 'ระบบฝาก-ถอนที่ปลอดภัยและรวดเร็ว: UFAgrand168 เข้าสู่ระบบ ฝาก-ถอนที่สะดวกและรวดเร็ว ผ่านการทำธุรกรรมออโต้ ซึ่งทำให้ผู้เล่นสามารถฝากหรือถอนเงินได้ทันที โดยไม่มีขั้นต่ำในการฝากถอน', 'โบนัสและโปรโมชั่น: UFAgrand168 มีการให้โบนัสและ โปรโมชั่น UFAgrand168 เครดิตฟรี, โบนัสฝากครั้งแรก, และโปรโมชั่นอื่นๆ ที่ช่วยเพิ่มมูลค่าให้กับผู้เล่น', 'สามารถเล่นผ่านมือถือ: UFAgrand168 รองรับการใช้งานผ่านมือถือทั้งระบบ iOS และ Android ทำให้ผู้เล่นสามารถเดิมพันได้ทุกที่ทุกเวลาอย่างสะดวกสบาย', 'ความปลอดภัย: UFAgrand168 ใช้เทคโนโลยีการเข้ารหัสขั้นสูงเพื่อรักษาความปลอดภัยของข้อมูลส่วนบุคคลและข้อมูลทางการเงินของผู้เล่น'] },
                                    { t: 'h3', cls: 'f-5 text-primary text-left', txt: 'ข้อเสียของ UFAgrand168' },
                                    { t: 'ol', items: ['อาจจะมีปัญหาการเข้าใช้งานในบางประเทศ: UFAgrand168 อาจไม่สามารถเข้าถึงได้ในบางประเทศที่มีกฎหมายการควบคุมการพนันที่เข้มงวด ทำให้ผู้เล่นในบางประเทศอาจพบปัญหาการเข้าใช้งาน', 'ข้อจำกัดในการถอนเงิน: บางครั้งอาจมีข้อจำกัดเกี่ยวกับการถอนเงิน เช่น การจำกัดจำนวนเงินในการถอนหรือระยะเวลาที่ใช้ในการทำธุรกรรม ซึ่งอาจทำให้ผู้เล่นบางรายรู้สึกไม่สะดวก', 'การติดการพนัน: เช่นเดียวกับการพนันออนไลน์ในทุกๆ เว็บไซต์ UFAgrand168 ก็มีความเสี่ยงที่จะทำให้ผู้เล่นติดการพนัน และเสี่ยงต่อการสูญเสียเงินจำนวนมาก ดังนั้นจึงควรเล่นอย่างมีความรับผิดชอบ', 'ข้อเสนอโปรโมชันที่ซับซ้อน: แม้ว่าจะมีโปรโมชันมากมาย แต่บางครั้งข้อเสนอเหล่านี้อาจมีเงื่อนไขที่ซับซ้อน ซึ่งอาจทำให้ผู้เล่นไม่เข้าใจข้อกำหนดและเงื่อนไขได้ง่าย', 'ข้อจำกัดในบางเกม: บางเกมใน UFAgrand168 อาจมีข้อจำกัดบางประการ เช่น การเดิมพันขั้นต่ำหรือการเดิมพันสูงสุด ซึ่งอาจไม่เหมาะสมกับผู้เล่นที่ต้องการวางเดิมพันในจำนวนเงินที่สูงหรือต่ำเกินไป'] },
                                    { t: 'h2', cls: 'f-4 text-primary', txt: 'สรุป UFAgrand168 เว็บตรง ต้อง UFAgrand168 เท่านั้น' },
                                    { t: 'p', txt: 'UFAgrand168 เป็นแพลตฟอร์มการพนันออนไลน์ที่ได้รับความนิยมสูง ด้วยการให้บริการที่หลากหลายทั้งการแทงบอลออนไลน์ การเดิมพันกีฬาอื่นๆ ทำให้ผู้เล่นสามารถเลือกเดิมพันได้ตามความชอบและความสะดวก แพลตฟอร์มนี้มีการให้บริการตลอด 24 ชั่วโมง พร้อมช่องทางการติดต่อที่หลากหลายและระบบฝาก-ถอนที่รวดเร็วและปลอดภัยผ่านการทำธุรกรรมออโต้ นอกจากนี้ยังมีโปรโมชั่นและโบนัสต่างๆ เช่น UFAgrand168 เครดิตฟรี ที่ช่วยเพิ่มโอกาสให้กับผู้เล่น' },
                                    { t: 'p', txt: 'UFAgrand168 ยังรองรับการใช้งานทั้งบนเว็บไซต์และแอปพลิเคชันมือถือในระบบ iOS และ Android ซึ่งทำให้ผู้เล่นสามารถเดิมพันได้ทุกที่ทุกเวลา พร้อมการรักษาความปลอดภัยด้วยเทคโนโลยีการเข้ารหัสขั้นสูงเพื่อปกป้องข้อมูลส่วนบุคคลและการเงินของผู้เล่น' },
                                    { t: 'p', txt: 'แม้ว่า UFAgrand168 จะมีข้อดีหลายประการ เช่น ความหลากหลายของเกมและบริการที่รวดเร็ว แต่ก็มีข้อเสียบางอย่างที่ควรพิจารณา เช่น ปัญหาในการเข้าใช้งานในบางประเทศที่มีกฎหมายการพนันที่เข้มงวด, ข้อจำกัดในการถอนเงิน หรือข้อกำหนดที่ซับซ้อนในบางโปรโมชัน นอกจากนี้การพนันออนไลน์ยังมีความเสี่ยงในการติดการพนันที่อาจส่งผลกระทบต่อผู้เล่นได้' },
                                    { t: 'p', txt: 'หากคุณกำลังมองหาเว็บพนันที่มั่นคง ปลอดภัย และครบวงจร UFAgrand168 ผ่าน UFAgrand168 คือคำตอบ สมัครง่าย จ่ายจริง มีเกมให้เลือกหลากหลาย พร้อมทีมงานดูแลตลอด 24 ชั่วโมง' },
                                    { t: 'p', txt: 'คลิกที่นี่เพื่อ สมัคร UFAgrand168 และเริ่มเดิมพันทันที!' },
                                    { t: 'h2', cls: 'f-4 text-primary', txt: 'ทางเข้า UFAgrand168 ผ่าน UFAgrand168 และ อื่น ๆ อีกมากมาย' },
                                ];
                                return (
                                    <section className="x-content-banner-vertical-component -bg-banner">
                                        <div className="container -content-wrapper">
                                            <div className="-text-wrapper">
                                                {seoBlocks.map((b, i) => {
                                                    if (b.t === 'h2') return <h2 key={i} className={b.cls}>{b.txt}</h2>;
                                                    if (b.t === 'h3') return <h3 key={i} className={b.cls}>{b.txt}</h3>;
                                                    if (b.t === 'ol') return <ol key={i} className="text-left">{b.items.map((it, j) => <li key={j}>{it}</li>)}</ol>;
                                                    return <p key={i}>{b.txt}</p>;
                                                })}
                                            </div>
                                        </div>
                                    </section>
                                );
                            })()}

                            {/* ข่าวสาร / Blog Section — markup ตาม reference (x-blog-section) */}
                            <div className="x-blog-section">
                                <div className="container-fluid">
                                    <h4 className="-section-title">ข่าวสาร</h4>
                                    <div className="animated fadeInUp">
                                        <div className="x-blog-card-list-container">
                                            <div className="row -list-row">
                                                {articles.map((a, i) => (
                                                    <div key={i} className="col-sm-6 col-md-4 col-lg-3 -list-item">
                                                        <div className="x-blog-card-list-item-container">
                                                            <a className="-card-wrapper" href="#" onClick={(e) => e.preventDefault()}>
                                                                <div className="-card-image">
                                                                    <img className="img-fluid -image" src={IMG + a.img} alt={a.title} />
                                                                </div>
                                                                <div className="-card-badge">UFAgrand168</div>
                                                                <h2 className="-card-title">{a.title}</h2>
                                                            </a>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="-all-blog-link-wrapper">
                                        <a href="#" onClick={(e) => e.preventDefault()}>ดูทั้งหมด</a>
                                    </div>
                                </div>
                            </div>

                            {/* ALL New Section */}
                            <section className="x-all-new-section" style={{ backgroundImage: `url(${IMG}all-new-section-bg.jpg)` }}>
                                <div className="container -container-inner-wrapper">
                                    <div className="-pre-title">
                                        <span className="-normal-text -highlight">UFAgrand168 ALL New</span>
                                        <span> ใหม่หมดต้อง </span>
                                        <a href="/" className="-highlight">UFAgrand168</a>
                                        <br className="d-none d-md-block" />
                                        <span className="-normal-text ml-1">ตอกย้ำความเป็น UFAgrand168 อันดับหนึ่งในไทย</span>
                                    </div>
                                </div>
                            </section>

                            {/* Provider Logo Sliders */}
                            {(() => {
                                const providers = [
                                    'ygg-gaming', 'evo-play', 'sp', 'ps', 'kingmaker', 'joker', 'habanero', 'ameba',
                                    'cq9', 'pg-soft', 'rich88', 'goldy', 'mg-slot', 'play-tech', 'pragmatic-play',
                                    'wm-slot', 'jili', 'netent-slot', 'only-play', 'kalamba', 'just-play',
                                    'fa-chai', 'gioco-plus', 'dragoon-soft', 'bbin-slot', 'isoftbet', 'red-tiger', 'relax-gaming',
                                ];
                                const sliderSettings = {
                                    arrows: false, dots: false, slidesToShow: 1, infinite: true,
                                    autoplay: true, autoplaySpeed: 0, variableWidth: true,
                                    swipe: false, speed: 3000, pauseOnHover: false, cssEase: 'linear',
                                };
                                return (
                                    <div className="x-ezs-provider-list">
                                        <Slider {...sliderSettings}>
                                            {providers.map((p, i) => (
                                                <div key={i} className="-slick-item">
                                                    <img alt={p} className="img-fluid -logo" width="128" height="42"
                                                        src={IMG + `logo-horizontal-light-wt-${p}.png`} />
                                                </div>
                                            ))}
                                        </Slider>
                                        <Slider {...{ ...sliderSettings, rtl: true }}>
                                            {[...providers].reverse().map((p, i) => (
                                                <div key={i} className="-slick-item">
                                                    <img alt={p} className="img-fluid -logo" width="128" height="42"
                                                        src={IMG + `logo-horizontal-light-wt-${p}.png`} />
                                                </div>
                                            ))}
                                        </Slider>
                                    </div>
                                );
                            })()}
                        </>
                    )}

                </div>

                {/* ======================== FOOTER — x-footer -three-columns ตาม reference ======================== */}
                {tabselect === 0 && (() => {
                    const footerTags = [
                        'UFAgrand168 เข้าสู่ระบบ', 'UFAgrand168 เว็บตรง', 'UFAgrand168 สมัคร', 'แทงบอล UFAgrand168', 'แทงบอลออนไลน์ UFAgrand168',
                        'สมัคร UFAgrand168 ผ่านมือถือ', 'UFAgrand168 มือถือ', 'เว็บ UFAgrand168 ที่ดีที่สุด', 'โบนัส UFAgrand168', 'ฝากถอน UFAgrand168',
                        'แทงบอลออนไลน์ UFAgrand168 ไม่มีขั้นต่ำ', 'เดิมพันกีฬา UFAgrand168', 'คาสิโนออนไลน์ UFAgrand168', 'บาคาร่า UFAgrand168', 'สล็อต UFAgrand168',
                        'UFAgrand168 คาสิโนสด', 'สูตรแทงบอล UFAgrand168', 'รีวิว UFAgrand168', 'แทงบอลสเต็ป UFAgrand168', 'UFAgrand168 ฝาก-ถอน ออโต้',
                        'โปรโมชั่น UFAgrand168', 'UFAgrand168 เครดิตฟรี', 'ทางเข้า UFAgrand168', 'UFAgrand168 เว็บตรงไม่ผ่านเอเย่นต์', 'เทคนิคการเล่น UFAgrand168',
                        'UFAgrand168 บาคาร่าออนไลน์', 'เกมยิงปลา UFAgrand168', 'แทงบอลเต็ง UFAgrand168', 'เดิมพันมวยออนไลน์ UFAgrand168', 'แทงหวย UFAgrand168',
                        'เว็บแทงบอล UFAgrand168', 'เดิมพันฟุตบอล UFAgrand168',
                    ];
                    return (
                        <footer className="x-footer -three-columns">
                            <div className="-inner-wrapper">
                                <div className="-row">
                                    {/* ซ้าย: โลโก้ + คำโปรย + ช่องทางการติดต่อ */}
                                    <div className="-column-left">
                                        <div className="-description-wrapper">
                                            <img className="-logo img-fluid" src={logoimg || IMG + 'logo.png'} alt="UFAgrand168" style={{ maxHeight: '56px', marginBottom: '12px' }} />
                                            <h4 className="-title">UFAgrand168 พนันบอลเว็บตรงเจ้าแรกในประเทศไทย</h4>
                                            <p>อัพเดทใหม่ ยิ่งใหญ่กว่าทุกเว็บ เจ้าเดียวในไทย ที่ได้รับการ ยินยอมจากเว็บตรงUFAgrand168 ให้นำมาเปิดบริการในประเทศไทย ราคาบอลดี ราคาน้ำสูง สมัครออโต้ ฝากถอนไว ซัพพอท 24ชม.</p>
                                            <h4 className="-title -contact-title" style={{ marginTop: '16px' }}>ช่องทางการติดต่อ</h4>
                                            <a className="-contact-link" href={linelink || '#'} style={{ display: 'inline-block', marginTop: '4px' }}>
                                                <img className="img-fluid" src={IMG + 'contact-us.png'} alt="LINE" style={{ maxHeight: '40px' }} />
                                            </a>
                                        </div>
                                    </div>
                                    {/* กลาง: แท็ก SEO (ชิปกว้างคงที่+ellipsis) + powered + nav */}
                                    <div className="-column-center">
                                        <div className="-tags-wrapper" style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', justifyContent: 'center' }}>
                                            {footerTags.map((t, i) => (
                                                <a key={i} className="btn btn-sm -btn-tag" href="#" onClick={(e) => e.preventDefault()} title={t}
                                                    style={{ width: '118px', display: 'inline-block', background: '#363633', color: '#eeeeee', borderRadius: '8px', padding: '5px 10px', fontSize: '13px', textDecoration: 'none', lineHeight: 1.4, textAlign: 'center', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{t}</a>
                                            ))}
                                        </div>
                                        <div className="-lower-section" style={{ textAlign: 'center', marginTop: '24px' }}>
                                            <div className="-powered" style={{ fontWeight: '600', marginBottom: '6px' }}>Powered by <a href="#" onClick={(e) => e.preventDefault()} style={{ color: 'inherit' }}>UFAgrand168</a></div>
                                            <ul className="-footer-nav" style={{ listStyle: 'none', display: 'inline-flex', flexWrap: 'wrap', justifyContent: 'center', gap: '0', padding: 0, margin: 0 }}>
                                                <li style={{ padding: '0 12px' }}><a href="/" onClick={(e) => { e.preventDefault(); this.checkurl(e, '/'); }}>หน้าแรก</a></li>
                                                <li style={{ padding: '0 12px', borderLeft: '1px solid rgba(255,255,255,0.3)' }}><a href="#" onClick={(e) => this.checkurl(e, '/sport')}>แทงบอลออนไลน์</a></li>
                                                <li style={{ padding: '0 12px', borderLeft: '1px solid rgba(255,255,255,0.3)' }}><a href="#" onClick={(e) => this.checkurl(e, '/slot')}>สล็อตออนไลน์</a></li>
                                                <li style={{ padding: '0 12px', borderLeft: '1px solid rgba(255,255,255,0.3)' }}><a href="#" onClick={(e) => this.checkurl(e, '/casino')}>คาสิโนออนไลน์</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                    {/* ขวา: ใบรับรองมาตรฐานคาสิโนสากล */}
                                    <div className="-column-right">
                                        <div className="-description-wrapper -wrapper-cert" style={{ textAlign: 'center' }}>
                                            <h4 className="-title">ใบรับรองมาตรฐานคาสิโนสากล</h4>
                                            <p style={{ marginTop: '12px' }}>Certified Fair Gambling</p>
                                            <p>Guarnteed Fast Pay Out</p>
                                            <p>BMM Testlab Certified</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* โลโก้ธนาคาร (CSS sprite ic-bank-logo.png วางตำแหน่งด้วย :nth-child) */}
                            <div className="container -image-wrapper d-flex justify-content-center">
                                <div className="x-footer-bank-logo">
                                    <div className="container">
                                        <div className="-wrapper">
                                            {Array.from({ length: 12 }).map((_, i) => (
                                                <div key={i} className={`-icon -ic-${i + 1} lazyloaded`}
                                                    style={{ backgroundImage: `url(${IMG}ic-bank-logo.png)`, backgroundSize: '194px', backgroundRepeat: 'no-repeat' }} />
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="-copyright-wrapper" style={{ textAlign: 'center' }}>
                                <p className="mb-0">Copyright &copy; 2025 <a href="#" onClick={(e) => e.preventDefault()}>UFAgrand168</a>. All Rights Reserved.</p>
                            </div>
                        </footer>
                    );
                })()}
                <div className="x-menu-footer -default">
                    <div className="-menu-wrapper">
                        <button
                            type="button"
                            className="-btn-item -btn-login-container"
                            onClick={() => { window.location.href = webnamex || '/signin'; }}
                        >
                            <picture>
                                <source type="image/webp" srcSet={IMG + 'ic-menu-login-animate.webp'} />
                                <source type="image/png" srcSet={IMG + 'ic-menu-login-animate.png'} />
                                <img alt="รูปไอคอนประจำเมนู" className="img-fluid" width={32} height={32} src={IMG + 'ic-menu-login-animate.png'} />
                            </picture>
                            <span className="-typo">เข้าระบบ</span>
                        </button>
                        <button
                            type="button"
                            className="-btn-item -btn-register-container"
                            onClick={() => { window.location.href = (webnamex || '') + '/register'; }}
                        >
                            <picture>
                                <source type="image/webp" srcSet={IMG + 'ic-menu-register.webp'} />
                                <source type="image/png" srcSet={IMG + 'ic-menu-register.png'} />
                                <img alt="รูปไอคอนประจำเมนู" className="img-fluid" width={32} height={32} src={IMG + 'ic-menu-register.png'} />
                            </picture>
                            <span className="-typo">สมัคร</span>
                        </button>
                        <a
                            href="#"
                            className="-btn-item -btn-promotion-container -special"
                            onClick={(e) => { e.preventDefault(); this.checkurl(e, '/promotion'); }}
                        >
                            <picture>
                                <source type="image/webp" srcSet={IMG + 'ic-menu-promotion-special.webp'} />
                                <source type="image/png" srcSet={IMG + 'ic-menu-promotion-special.png'} />
                                <img alt="รูปไอคอนประจำเมนู" className="img-fluid" width={32} height={32} src={IMG + 'ic-menu-promotion-special.png'} />
                            </picture>
                            <span className="-typo">โปรโมชัน</span>
                        </a>
                        <a
                            href={linelink || '#'}
                            className="-btn-item -btn-line-container"
                            target="_blank"
                            rel="noopener"
                        >
                            <picture>
                                <source type="image/webp" srcSet={IMG + 'ic-menu-line.webp'} />
                                <source type="image/png" srcSet={IMG + 'ic-menu-line.png'} />
                                <img alt="รูปไอคอนประจำเมนู" className="img-fluid" width={32} height={32} src={IMG + 'ic-menu-line.png'} />
                            </picture>
                            <span className="-typo">แอดไลน์</span>
                        </a>
                        <a
                             href={linelink || '#'}
                            className="-btn-item -btn-telegram-container"
                            target="_blank"
                            rel="noopener"
                        >
                            <picture>
                                <source type="image/webp" srcSet={IMG + 'ic-menu-telegram.webp'} />
                                <source type="image/png" srcSet={IMG + 'ic-menu-telegram.png'} />
                                <img alt="รูปไอคอนประจำเมนู" className="img-fluid" width={30} height={30} src={IMG + 'ic-menu-telegram.png'} />
                            </picture>
                            <span className="-typo">Telegram</span>
                        </a>
                        <a
                            href="#"
                            className="-btn-item -btn-ball-live-container"
                            target="_blank"
                            rel="noopener"
                        >
                            <img alt="รูปไอคอนประจำเมนู" className="img-fluid" width={32} height={32} src={IMG + 'ic-menu-ball-live.png'} />
                            <span className="-typo">บอลสด</span>
                        </a>
                    </div>
                </div>

                <ToastContainer />
            </>
        );
    }
}

export default Main;
